import { RetailElectronAPI } from './common/electron/RetailElectronAPI';
import XLRLogger from './common/helpers/logger';
import { CustomerDisplayLifecycle } from './customer-display/hooks/useCustomerDisplay';

export const registerMainWindowListener = async (port: MessagePort) => {
  const mainWindowController = RetailElectronAPI.getMainWindowController();
  const custDisplayController = RetailElectronAPI.getCustomerDisplayController();
  // receiving data from electron IPC actions in main thread and piping it into the message channel
  mainWindowController.registerMainWindowDataListener((event, data) => {
    // if we get the 'all ready' signal from the customer display we can connect the pipes
    if (data === CustomerDisplayLifecycle.Loaded) {
      // buffers data until connected on customer display side
      port.onmessage = event => {
        XLRLogger.debug({ message: 'sending ipc data:', data: event.data });
        custDisplayController.sendToCustomerDisplay(event.data);
      };
    }
    XLRLogger.debug({ message: 'ipc event data:', data });
    port.postMessage(data);
  });
};
